import { render, staticRenderFns } from "./LatestNews.vue?vue&type=template&id=a5b2b8cc&scoped=true&"
import script from "./LatestNews.vue?vue&type=script&lang=js&"
export * from "./LatestNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b2b8cc",
  null
  
)

export default component.exports